// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"1275f36e","714":"440a341f"}[chunkId] + ".chunk.css";
};